import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
/* src/app/page.admin/view.scss: no such file or directory */`],
})
export class PageAdminComponent implements OnInit, DoCheck {
    constructor(@Inject( Service) public service: Service) { }

    public main: string = '';
    public sub: string = '';
    public id: string = '';
    public menu: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership("admin", "/");
        this.main = WizRoute.segment.main;
        this.sub = WizRoute.segment.sub;
        this.id = WizRoute.segment.id;
        this.menu = WizRoute.segment.menu;
        await this.service.render();

        if (!WizRoute.segment.main)
            return this.service.href("/admin/community");
    }

    public async ngDoCheck() {
        if (!WizRoute.segment.main)
            return this.service.href("/admin/community");
        this.main = WizRoute.segment.main;
        this.sub = WizRoute.segment.sub;
        this.id = WizRoute.segment.id;
        this.menu = WizRoute.segment.menu;
    }
}

export default PageAdminComponent;